export default class ListActionErrors {
    static fromData(data) {
        const listActionErrors = new ListActionErrors();

        listActionErrors.errorCount = data.errorCount;
        listActionErrors.errors = data.errors.data.map((error) => {
            return {
                errorMessage: error.error,
                entityType: error.entityType,
                entityId: error.entityId,
                entity: this.entityFromData(error.entity.data, error.entityType),
            }
        });
        return listActionErrors;
    }

    static entityFromData(entity, type) {
        if ('ClubMember' === type) {
            return {
                id: entity.id,
                firstName: entity.firstName,
                lastName: entity.lastName,
                membershipNumber: entity.membershipNumber
            }
        }
        if ('ClubDog' === type) {
            return {
                id: entity.id,
                name: entity.name,
                chipNumber: entity.chipNumber,
            }
        }
        if ('MemberClubFee' === type) {
            return {
                id: entity.id,
                feeName: entity.feeName,
                firstName: entity.firstName,
                lastName: entity.lastName,
            }
        }
    }
}
